import { gql } from '@apollo/client';

// this can used ads get activities for client / all activities for coach for now
// client id and coach id are optional used for filtering in future
export const GET_ACTIVITY_FOR_CLIENT = gql`
  query GetActivities {
    getActivities {
      id
      clientId
      coachId
      name
      objective
      schedule
      repeatOn
      customMessage
      description
      isCompleted
      nextCreate
      isActive
      createdAt
      updatedAt
      archived
      expiredAt
      startAt
      ActivityStep {
        id
        activityId
        description
        stepOrder
        text
        asset
        createdAt
        updatedAt
      }
    }
  }
`;
export const GET_ACTIVITY_FOR_CLIENT_BY_ID = gql`
  query GetActivitiesForClient(
    $clientId: String!
    $coachId: String!
    $skip: Int!
    $take: Int!
    $filterText: String!
    $schedule: ActivitySchedule
  ) {
    getActivitiesForClient(
      clientId: $clientId
      coachId: $coachId
      take: $take
      skip: $skip
      filterText: $filterText
      schedule: $schedule
    ) {
      totalActivityCount
      isActivityCreated
      activities {
        id
        clientId
        coachId
        name
        objective
        schedule
        repeatOn
        customMessage
        description
        isCompleted
        nextCreate
        isActive
        createdAt
        updatedAt
        archived
        coverImage
        expiredAt
        startAt
        isUserCreated
        isSharedWithCoach
        ActivityStep {
          id
          activityId
          description
          stepOrder
          text
          asset
          assetType
          createdAt
          updatedAt
          isAdvanceStep
        }
      }
    }
  }
`;

export const GET_TOTAL_ACTIVITIES_COUNT_FOR_CLIENT = gql`
  query GetActivitiesForClient($coachId: String!, $clientId: String!) {
    getActivitiesForClient(coachId: $coachId, clientId: $clientId) {
      totalActivityCount
    }
  }
`;

export const GET_USER_ACTIVITIES = gql`
  query GetUserActivities($activityId: String!) {
    getUserActivities(activityId: $activityId) {
      id
      activityId
      currentStep
      completedAt
      createdAt
      updatedAt
    }
  }
`;

export const ADD_NEW_ACTIVITY = gql`
  mutation AddNewActivity(
    $clientId: String!
    $coachId: String!
    $name: String!
    $objective: String!
    $repeatOn: [Int!]!
    $customMessage: String
    $isCompleted: Boolean!
    $steps: [StepsType!]!
    $schedule: ActivitySchedule!
    $startAt: DateTime!
    $isAddToLibrary: Boolean!
  ) {
    addActivity(
      addActivityInput: {
        clientId: $clientId
        coachId: $coachId
        name: $name
        objective: $objective
        schedule: $schedule
        repeatOn: $repeatOn
        customMessage: $customMessage
        isCompleted: $isCompleted
        steps: $steps
        startAt: $startAt
        isAddToLibrary: $isAddToLibrary
      }
    ) {
      activity {
        id
        name
        objective
        schedule
        repeatOn
        customMessage
        isCompleted
        isActive
        createdAt
        updatedAt
        startAt
      }
      activityStep {
        id
        activityId
        description
        stepOrder
        text
        asset
        assetType
        link
        createdAt
        updatedAt
      }
    }
  }
`;

export const GET_MAGIC_SUGGESTIONS = gql`
  query GetMagicSuggestions($clientId: String!, $coachId: String!) {
    getMagicSuggestions(clientId: $clientId, coachId: $coachId) {
      id
      suggestions {
        activities {
          advance_activity_tracking_steps
          title
          frequency
          situation
          summary
          steps
        }
      }
      clientId
      is_completed
    }
  }
`;

export const SUBSCRIBE_TO_MAGIC_SUGGESTIONS = gql`
  subscription SubscribeToMagicSuggestons($magicSuggestionId: String!) {
    magicSuggestions(magicSuggestionId: $magicSuggestionId) {
      id
      suggestions {
        activities {
          advance_activity_tracking_steps
          title
          frequency
          situation
          summary
          steps
        }
      }
      clientId
      is_completed
    }
  }
`;

export const EDIT_ACTIVITY = gql`
  mutation EditActivity($editActivityInput: EditActivityInput!) {
    editActivity(editActivityInput: $editActivityInput) {
      id
      name
      objective
      coverImage
      schedule
      repeatOn
      customMessage
      description
      isCompleted
      nextCreate
      isActive
      createdAt
      updatedAt
      expiredAt
      archived
      startAt
      ActivityStep {
        id
        activityId
        description
        stepOrder
        text
        asset
        assetType
        createdAt
        updatedAt
        isAdvanceStep
      }
    }
  }
`;

export const CHECK_ACTIVITY_EXISTENCE = gql`
  query checkActivityExistence($checkActivityExistenceArgs: CheckActivityExistenceInput!) {
    checkActivityExistence(checkActivityExistenceArgs: $checkActivityExistenceArgs) {
      success
      message
    }
  }
`;
